"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordRelease = recordRelease;
exports.backfillReleases = backfillReleases;
const derived_1 = require("../../core/dist/derived");
const dates_1 = require("../../core/dist/dates");
function recordReleaseEvent(planId, release) {
    return { type: 'RECORD_RELEASE', planId, release };
}
/** Live mode — stamp `version` onto every unstamped done plan. */
async function recordRelease(input, deps) {
    if (!input.version || !input.version.trim()) {
        throw new Error('recordRelease requires a non-empty version.');
    }
    const state = await deps.loadState();
    const { history } = (0, derived_1.buildRoadmap)(state); // done plans only, with weaveSlug/threadSlug/date/release
    const stamped = [];
    const skipped = [];
    for (const sp of history) {
        if (sp.release != null && !input.overwrite) {
            skipped.push({ planId: sp.planId, reason: 'already-stamped' });
            continue;
        }
        await deps.runEvent(sp.weaveSlug, recordReleaseEvent(sp.planId, input.version));
        stamped.push({ planId: sp.planId, threadSlug: sp.threadSlug, weaveSlug: sp.weaveSlug, release: input.version });
    }
    return { stamped, skipped };
}
/**
 * The version a plan done on `date` belongs to: the earliest release tagged on or
 * after that date — i.e. the release whose `(prevReleaseDate, thisReleaseDate]`
 * window contains the done-date. A plan done after the last known release is
 * unshipped (returns null).
 */
function versionForDate(date, ascendingByDate) {
    for (const r of ascendingByDate) {
        if ((0, dates_1.compareDates)(date, r.date) <= 0)
            return r.version;
    }
    return null;
}
/** Backfill mode — assign each done plan to its release by done-date. */
async function backfillReleases(input, deps) {
    const ascending = [...(input.releaseDates ?? [])].sort((a, b) => (0, dates_1.compareDates)(a.date, b.date));
    const state = await deps.loadState();
    const { history } = (0, derived_1.buildRoadmap)(state);
    const stamped = [];
    const skipped = [];
    for (const sp of history) {
        if (sp.release != null && !input.overwrite) {
            skipped.push({ planId: sp.planId, reason: 'already-stamped' });
            continue;
        }
        const version = versionForDate(sp.date, ascending);
        if (!version) {
            skipped.push({ planId: sp.planId, reason: 'unshipped' });
            continue;
        }
        await deps.runEvent(sp.weaveSlug, recordReleaseEvent(sp.planId, version));
        stamped.push({ planId: sp.planId, threadSlug: sp.threadSlug, weaveSlug: sp.weaveSlug, release: version });
    }
    return { stamped, skipped };
}
